const syncTextFields = document.querySelectorAll<HTMLSelectElement>('[data-syncfieldtext]')
const syncFields = document.querySelectorAll<HTMLInputElement>('[data-syncfield]')

syncTextFields.forEach(el => {
    el.addEventListener('change', function () {
        document.querySelectorAll<HTMLInputElement>(this.getAttribute('data-syncfieldtext') ?? '').forEach(syncEl => {
            if (el.selectedIndex > 0) {
                syncEl[syncEl.tagName === 'INPUT' || syncEl.tagName === 'TEXTAREA' || syncEl.tagName === 'SELECT' ? 'value' : 'innerHTML'] = el.options[el.selectedIndex].text;
            }
        });
    });
});

syncFields.forEach(el => {
    el.addEventListener('input', function () {
        let format = this.getAttribute('data-syncformat')

        document.querySelectorAll<HTMLInputElement>(this.getAttribute('data-syncfield') ?? '').forEach(syncEl => {
            let val = this.value

            if (format == 'number') {
                val = val.replace('$', '').replace(/,/g, '')
            }

            syncEl[syncEl.tagName === 'INPUT' || syncEl.tagName === 'TEXTAREA' || syncEl.tagName === 'SELECT' ? 'value' : 'innerHTML'] = val;
        })
    });
});